var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Paper, Typography, Box, Snackbar, Alert, CircularProgress, } from '@mui/material';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { resetPasswordAsync } from '../redux/authSlice';
import { PasswordField } from './PasswordField';
export const ResetPasswordForm = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const authStatus = useSelector((state) => state.auth.status);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordError, setPasswordError] = useState();
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const handlePasswordChange = (e) => {
        const newPassword = e.target.value;
        setPassword(newPassword);
        setPasswordError(confirmPassword && newPassword !== confirmPassword
            ? 'Passwords do not match'
            : '');
    };
    const handleConfirmPasswordChange = (e) => {
        const newConfirmPassword = e.target.value;
        setConfirmPassword(newConfirmPassword);
        setPasswordError(newConfirmPassword && newConfirmPassword !== password
            ? 'Passwords do not match'
            : '');
    };
    const isFormInvalid = () => {
        return !password || !confirmPassword || password !== confirmPassword;
    };
    const handleSubmit = (event) => __awaiter(void 0, void 0, void 0, function* () {
        event.preventDefault();
        if (!token) {
            setErrorMessage('Invalid or missing token.');
            setSnackbarOpen(true);
            return;
        }
        if (isFormInvalid()) {
            setErrorMessage('Please fix the errors before submitting.');
            setSnackbarOpen(true);
            return;
        }
        try {
            yield dispatch(resetPasswordAsync({ token, password })).unwrap();
            setErrorMessage(null);
            setSnackbarOpen(true);
            navigate('/login');
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }
        catch (error) {
            // Handle error
            setErrorMessage(error.message ||
                'An error occurred while resetting the password.');
            setSnackbarOpen(true);
        }
    });
    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
    };
    return (_jsxs(Box, Object.assign({ sx: { width: '400px', maxWidth: '100%' } }, { children: [_jsxs(Paper, Object.assign({ elevation: 3, sx: { padding: 3 } }, { children: [_jsx(Typography, Object.assign({ variant: "h5", gutterBottom: true }, { children: "Reset Password" })), _jsxs("form", Object.assign({ onSubmit: handleSubmit }, { children: [_jsx(PasswordField, { value: password, onChange: handlePasswordChange, label: "New Password", id: "new-password", required: true, testId: "input-new-password" }), _jsx(PasswordField, { value: confirmPassword, onChange: handleConfirmPasswordChange, label: "Confirm New Password", id: "confirm-new-password", required: true, error: !!passwordError, helperText: passwordError, testId: "input-confirm-new-password" }), _jsx(Button, Object.assign({ type: "submit", variant: "contained", color: "primary", fullWidth: true, sx: { mt: 2 }, disabled: authStatus === 'loading' || isFormInvalid(), "data-testid": "button-submit", startIcon: authStatus === 'loading' && (_jsx(CircularProgress, { size: 20, color: "inherit" })) }, { children: "Reset Password" }))] }))] })), _jsx(Snackbar, Object.assign({ open: snackbarOpen, autoHideDuration: 6000, onClose: handleCloseSnackbar, anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, "data-testid": "snackbar" }, { children: _jsx(Alert, Object.assign({ severity: errorMessage ? 'error' : 'success', onClose: handleCloseSnackbar, sx: { width: '100%' }, "data-testid": "alert" }, { children: errorMessage || 'Password has been reset!' })) }))] })));
};
